import { useTranslation } from "react-i18next";
import { isNumericGuard } from "utils/dataManipulation";

import { PerformanceRatioCard } from "./PerformanceRatioCard";
import { getPerformanceRatioStatus, PERFORMANCE_RATIO_THRESHOLD } from "./performanceRatioUtils";

type EPCPerformanceRatioSectionProps = {
  epcInfo?: {
    consumption_of_energy_vs_reference_label: null | string | undefined;
    consumption_vs_reference: number | undefined;
    primary_energy_kwh_per_m2: number | undefined;
    primary_energy_reference_kwh_per_m2: number | undefined;
  };
};

export const EPCPerformanceRatioSection = ({ epcInfo }: EPCPerformanceRatioSectionProps) => {
  const { t } = useTranslation();
  const status = getPerformanceRatioStatus(epcInfo?.consumption_of_energy_vs_reference_label);
  const buildingValue = epcInfo?.primary_energy_kwh_per_m2;
  const referenceValue = epcInfo?.primary_energy_reference_kwh_per_m2;
  const ratio = epcInfo?.consumption_vs_reference;

  if (!isNumericGuard(ratio)) return null;

  return (
    <PerformanceRatioCard
      buildingValue={buildingValue}
      className="mt-20 w-full"
      ratio={ratio}
      referenceValue={referenceValue}
      status={status}
      threshold={PERFORMANCE_RATIO_THRESHOLD}
      title={t("BuildingProfile.kpis.performanceRatio")}
    />
  );
};
